// Wholesale is fulfilled off-site via the downloadable PDF price sheet.
// On-page price list was intentionally removed (prices are maintained only in the PDF).
export const WHOLESALE_MIN = 500;
export const WHOLESALE_PHONE = "(404) 913-1814";
export const WHOLESALE_PHONE_RAW = "+14049131814";
export const WHOLESALE_EMAIL = "support@itsmybalance.com";
